import { useLang } from 'hooks/lang';

import { projectStatusByCode } from 'entities';

import { Button } from 'components/Blocks';

import { UserOwnershipBreakdown } from '../components';

import { useProject } from 'providers/Project';
import { useUser } from 'hooks';

import { resolveColorClass } from 'styles';
import { truncateText } from 'utils/text';

export function ActiveProjectsByUser() {
  const { t } = useLang();
  const user = useUser();

  const { projects: appProjects, loadingProjects } = useProject();

  return (
    <UserOwnershipBreakdown
      title={t('active-projects-per-user')!}
      statusConfig={projectStatusByCode}
      loading={loadingProjects}
      entries={Object.values(appProjects).filter(
        ({ teamResponsible, status }) =>
          teamResponsible === user.team.id && projectStatusByCode[status].isActiveStatus,
      )}
      render={(project) => (
        <Button
          tooltipContent={project.name}
          variant="ghost"
          to="projectProfile"
          params={{ projectId: project.id }}
          linkTarget={project.id}
          className={resolveColorClass(projectStatusByCode[project.status].color, 'text')}
        >
          {truncateText(project.name, 35)}
        </Button>
      )}
    />
  );
}
